<!--Title-->
<h1 mat-dialog-title *ngIf="dialogTitle">{{dialogTitle}}</h1>

<!--Content-->
<mat-dialog-content mat-dialog-content class="mat-typography" *ngIf="dialogMessage">
  <h4 class="fw-500 text-dark">{{dialogMessage}}</h4>
</mat-dialog-content>

<div *ngIf="isInput">
  <label>Email or Mobile<sup class="error">*</sup></label>
  <app-input (onChangeEvent)="EmailData($event)"></app-input>
</div>

<!--Actions-->
<div mat-dialog-actions>
  <button mat-button mat-dialog-close *ngIf="dailogCancelBtnTitle">{{dailogCancelBtnTitle}}</button>
  <button class="deleteStore" mat-button cdkFocusInitial *ngIf="dailogSuccessBtnTitle"
    (click)="onSuccess()">{{dailogSuccessBtnTitle}}</button>
</div>